module.exports = __webpack_public_path__ + "static/media/vscode.2a1a2beb.svg";